import { KSpan, KTooltip } from "kahuna-base-react-components"
import { TABLE_COLUMN_TYPE } from "../../../../../constants"
import { TableColumn } from "../../../../../types"
import { TrackPerformanceDetails } from "../TrackPerformance"
import TruncatedListWithTooltip from "../../../playlists/components/TruncatedListWithTooltip.tsx"
//@ts-ignore
import IncreasingIcon from "../../../../../assets/analytics_icons/trend-up.svg"
//@ts-ignore
import SteadyIcon from "../../../../../assets/analytics_icons/steady.svg"
//@ts-ignore
import DecreasingIcon from "../../../../../assets/analytics_icons/trend-down.svg"
import { lang } from "../../../../../constants/languages/index.tsx"
import { getPercentage } from "../../../../../utility/index.ts"
//@ts-ignore
import ArrowUpIcon from "../../../../../assets/analytics_icons/arrow-up-green.svg"
//@ts-ignore
import ArrowDownIcon from "../../../../../assets/analytics_icons/arrow-down-red.svg"
//@ts-ignore
import InfoCircle from "../../../../../assets/analytics_icons/info-circle.svg"

const getTrendingIcon = (selectedWeek: number, previousWeek: number) => {
  if (previousWeek === 0 && selectedWeek === 0) {
    return SteadyIcon
  }
  if (previousWeek === 0 && selectedWeek !== 0) {
    return IncreasingIcon
  }

  const change = ((selectedWeek - previousWeek) / previousWeek) * 100

  if (change > 15) {
    return IncreasingIcon
  } else if (change <= 15 && change >= -15) {
    return SteadyIcon
  } else {
    return DecreasingIcon
  }
}

const trackTitle: TableColumn = {
  header: lang.analytics.track,
  headerStyle: {
    textAlign: "left",
    width: "25%"
  },
  //sortable: true,
  //sortFilterField: "title",
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    return (
      <div className="flex w-max flex-col gap-1p">
        <div className="flex items-center">
          <KSpan text={row?.track?.title || "-"} color="#000" fontWeight={500} fontSize={13} />
        </div>
        {
          <TruncatedListWithTooltip
            itemList={row?.track?.artistList.map((artist) => artist.name) || []}
            visibleItemCount={3}
            breakPointInPx={1200}
            smallScreenVisibleItemCount={2}
            title={""}
          />
        }
      </div>
    )
  }
}

const isrc: TableColumn = {
  header: "ISRC",
  headerStyle: {
    textAlign: "left",
    width: "15%"
  },
  //sortable: true,
  //sortFilterField: "title",
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    return (
      <div className="flex">
        <div className="rounded-[4px] bg-[#F7F7F7] flex items-center px-1.5 py-1 w-auto">
          <div className=" flex flex-row items-center pr-1">
            <KSpan
              text={row?.isrc || "-"}
              color="#111"
              fontSize={12}
              fontWeight={500}
              lineHeight="16px"
              letterSpacing="0.22px"
            />
          </div>
        </div>
      </div>
    )
  }
}

const streams: TableColumn = {
  header: lang.trends.streams,
  headerStyle: {
    textAlign: "left",
    width: "12%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    const percentChange = getPercentage(row?.previousWeek.dsp, row?.selectedWeek?.dsp) ?? undefined

    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={row?.selectedWeek?.dsp?.toString() || ""} color="#111" fontSize={13} />
        {!!percentChange && (
          <div className="flex flex-row items-center gap-[0px] pb-[1px]">
            <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
            <KSpan
              text={`${percentChange.toFixed(0)}%`}
              color={percentChange > 0 ? "#318D18" : "#D02E20"}
              fontSize={11}
              lineHeight="14px"
            />
          </div>
        )}
      </div>
    )
  }
}

const downloads: TableColumn = {
  header: lang.trends.headers.downloads,
  headerStyle: {
    textAlign: "left",
    width: "12%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    const percentChange = getPercentage(row?.previousWeek.download, row?.selectedWeek?.download) ?? undefined
    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={row?.selectedWeek.download?.toString() || ""} color="#111" fontSize={13} />
        {!!percentChange && (
          <div className="flex flex-row items-center gap-[0px] pb-[1px]">
            <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
            <KSpan
              text={`${percentChange.toFixed(0)}%`}
              color={percentChange > 0 ? "#318D18" : "#D02E20"}
              fontSize={11}
              lineHeight="14px"
            />
          </div>
        )}
      </div>
    )
  }
}

const videosCreated: TableColumn = {
  header: lang.trends.headers.videos_created,
  headerStyle: {
    textAlign: "left",
    width: "12%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    const percentChange =
      getPercentage(row?.previousWeek.socialProduction, row?.selectedWeek?.socialProduction) ?? undefined

    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={row?.selectedWeek.socialProduction?.toString() || ""} color="#111" fontSize={13} />
        {!!percentChange && (
          <div className="flex flex-row items-center gap-[0px] pb-[1px]">
            <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
            <KSpan
              text={`${percentChange.toFixed(0)}%`}
              color={percentChange > 0 ? "#318D18" : "#D02E20"}
              fontSize={11}
              lineHeight="14px"
            />
          </div>
        )}
      </div>
    )
  }
}

const videoViews: TableColumn = {
  header: lang.trends.headers.video_views,
  headerStyle: {
    textAlign: "left",
    width: "12%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    const percentChange =
      getPercentage(row?.previousWeek.socialConsumption, row?.selectedWeek?.socialConsumption) ?? undefined

    return (
      <div className="flex w-max flex-row gap-1">
        <KSpan text={row?.selectedWeek.socialConsumption?.toString() || ""} color="#111" fontSize={13} />
        {!!percentChange && (
          <div className="flex flex-row items-center gap-[0px] pb-[1px]">
            <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
            <KSpan
              text={`${percentChange.toFixed(0)}%`}
              color={percentChange > 0 ? "#318D18" : "#D02E20"}
              fontSize={11}
              lineHeight="14px"
            />
          </div>
        )}
      </div>
    )
  }
}

const trends: TableColumn = {
  header: "Trend",
  headerStyle: {
    textAlign: "left",
    width: "10%"
  },
  type: TABLE_COLUMN_TYPE.FUNCTION,
  render: (row: TrackPerformanceDetails) => {
    const icon = getTrendingIcon(row.selectedWeek.dsp, row.previousWeek.dsp)
    return (
      <div className="flex w-max flex-col gap-1">
        {icon && <img src={icon} className="w-6 h-6 min-w-6 min-h-6" alt="trending-icon" />}
      </div>
    )
  }
}

const trackPerformanceTableColumns = (eventType: string, selectedCountriesCount: number): TableColumn[] => {
  const skips: TableColumn = {
    header: lang.trends.skips,
    overrideHeader: () => {
      return (
        <div className="flex flex-row items-center gap-1">
          <KSpan text={lang.trends.skips} color="#111" fontWeight={500} fontSize={14} />
          <KTooltip
            padding="8px"
            position="bottom"
            marginLeft="-20px"
            content={
              <div className="h-auto w-[300px] flex items-start justify-center flex-col gap-3">
                <KSpan text={`- ${lang.trends.skips_tooltip_platform}`} fontSize={12} lineHeight="16px" color="#111" />
                <KSpan text={`- ${lang.trends.skips_tooltip_country}`} fontSize={12} lineHeight="16px" color="#111" />
              </div>
            }
          >
            <img src={InfoCircle} className="w-4 h-4 min-w-4 min-h-4" alt="trending-icon" />
          </KTooltip>
        </div>
      )
    },
    headerStyle: {
      textAlign: "left",
      width: "12%"
    },
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: TrackPerformanceDetails) => {
      //const percentChange = getPercentage(row?.previousWeek.skips, row?.selectedWeek?.skips) ?? undefined
      const text = selectedCountriesCount > 0 ? "-" : row?.selectedWeek.skips?.toString() || ""
      return (
        <div className="flex w-max flex-row gap-1">
          <KSpan text={text} color="#111" fontSize={13} />
          {/*!!percentChange && (
            <div className="flex flex-row items-center gap-[0px] pb-[1px]">
              <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={14} width={14} />
              <KSpan
                text={`${percentChange.toFixed(1)}%`}
                color={percentChange > 0 ? "#318D18" : "#D02E20"}
                fontSize={11}
                lineHeight="14px"
              />
            </div>
          )*/}
        </div>
      )
    }
  }
  const columns: TableColumn[] = []
  if (eventType === "dsp") {
    columns.push(trackTitle)
    columns.push(isrc)
    columns.push(streams)
    columns.push(skips)
    columns.push(trends)
  } else if (eventType === "social") {
    columns.push(trackTitle)
    columns.push(isrc)

    columns.push(videoViews)
    columns.push(videosCreated)
  } else if (eventType === "download") {
    columns.push(trackTitle)
    columns.push(isrc)

    columns.push(downloads)
  }
  return columns
}

export default trackPerformanceTableColumns
